module.exports = __webpack_public_path__ + "img/cl_five_steps_2.c1810b89.png";